import { render } from "./AddParametreModal.vue?vue&type=template&id=3f63b052&scoped=true&ts=true"
import script from "./AddParametreModal.vue?vue&type=script&lang=ts"
export * from "./AddParametreModal.vue?vue&type=script&lang=ts"

import "./AddParametreModal.vue?vue&type=style&index=0&id=3f63b052&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f63b052"]])

export default __exports__